import React from 'react'

import { createStyles, Grid, GridProps } from '@mui/material'
import { WithStyles, withStyles } from '@mui/styles'

const GridContainer: React.FunctionComponent<GridContainerPropsWithStyles> = ({
  classes,
  children,
  className,
  ...rest
}) => {
  return (
    <Grid container {...rest} className={classes.grid + ' ' + className}>
      {children}
    </Grid>
  )
}

type GridContainerPropsWithStyles = GridContainerProps & WithStyles<typeof styles>

type GridContainerProps = {
  children: React.ReactNode
  className?: string
  justify?: GridProps['justifyContent']
}

const styles = () =>
  createStyles({
    grid: {
      marginRight: '-15px',
      marginLeft: '-15px',
      width: 'auto',
    },
  })

export default withStyles(styles)(GridContainer)
